require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('styles/App.css');

import React from 'react';
import MastheadComponent from '../masthead/MastheadComponent';
import Tracking from 'ta-react-tracking';

// import FeedbackMessage from '../feedbackMessage/FeedbackMessage.component';
// import CopyRightNotice from '../copyrightNotice/CopyrightNotice.component';

import Storyhead from '../storyhead/Storyhead';
import Identificator from '../identificator/Identificator';
import Section1 from '../section1/Section1';
import Section2 from '../section2/Section2';
import Section3 from '../section3/Section3';
import Section4 from '../section4/section4';
import Section5 from '../section5/section5';
import Section6 from '../section6/section6';
// import Linechart from '../lineChart/Linechart.component';
import MultipleLineChart from '../multipleLineChart/MultipleLineChart';
import SmallMultiples from '../smallMultiples/SmallMultiples';
import SVGQuarterMap from '../svgQuarterMap/SVGMap.component';
// import SVGCircleMap from '../svgCircleMap/SVGMap.component';
import Video from '../video/Video.component';
import Footer from '../footer/Footer.component';

import ContainerDimensions from 'react-container-dimensions';

import zhQuarterMap from '../svgQuarterMap/data/zhQuarterMap.svg';
// import zhCircleMap from '../svgCircleMap/data/zhCircleMap.svg';

import zhQuarterMapData from 'json!../svgQuarterMap/data/zhQuarterMapSoziahilfe.json';
// import zhCircleMapData from 'json!../svgQuarterMap/data/zhCircleMap.json';

class AppComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showQuarterList: false,
      readerIsCityCitizen: false,
      readerMadeHisChoice: false,
      chosenQuarter: '',
      showOverlay: false,
      dataSource: [
        {day:'02-11-1999',title:'Kreis 1',count:500},
        {day:'02-12-2000',title:'Kreis 2',count:250},
        {day:'02-13-2001',title:'Kreis 3',count:50},
        {day:'02-14-2002',title:'Kreis 4',count:500},
        {day:'02-15-2003',title:'Kreis 5',count:0},
        {day:'02-16-2004',title:'Kreis 6',count:380},
        {day:'02-17-2005',title:'Kreis 7',count:100},
        {day:'02-18-2006',title:'Kreis 8',count:300},
        {day:'02-16-2007',title:'Kreis 6',count:380},
        {day:'02-17-2008',title:'Kreis 7',count:100},
        {day:'02-18-2009',title:'Kreis 8',count:300}
      ]
    }

    this.changeCitizenship = this.changeCitizenship.bind(this);
    this.changeChosenQuarter = this.changeChosenQuarter.bind(this);


  }



  changeChosenQuarter(newChoice) {
    this.setState({
      chosenQuarter: newChoice
    });
  }

  changeCitizenship(quarter,choice,choiceIsMade) {
    this.setState({
      chosenQuarter: quarter,
      readerIsCityCitizen: choice,
      readerMadeHisChoice: choiceIsMade,
      showQuarterList: false
    });
    if(quarter) {
      this.setState({
        chosenQuarterName: quarter.name,
        chosenCircleName: quarter.circle,
        readerMadeHisChoice: true,
        readerIsCityCitizen: true
      })
    }

  }

  random = Math.random()*100000;

  render() {

    return (

      <div
        className='index'
      >

        <div style={{
          position: 'absolute'
        }}
        >
          <img
            style={{
              display: 'none'
            }}
            src={`http://www.tagesanzeiger.ch/zuerich/Oliver-45--ploetzlich-arm-im-reichen-Zuerich/story/19748408/pixel.gif?nocache=${this.random}`}
            width='1'
            height='1'
          />
        </div>


        <MastheadComponent
          inverted='true'
          mediaName='tagesanzeiger'
          shareUrl='http://interaktiv.tagesanzeiger.ch/2016/armut-in-zuerich/'
          twitterShareText='In Zürich leben Zehntausende Menschen in Armut. Oliver ist einer von ihnen. Eine Abstiegsgeschichte.'/>

        <div
          style={{
            height: '100vh'
          }}
        >

          <ContainerDimensions>

            <Storyhead
            />

          </ContainerDimensions>
        </div>

        <ContainerDimensions>
          <Identificator
            readerIsCityCitizen={this.state.readerIsCityCitizen}
            readerMadeHisChoice={this.state.readerMadeHisChoice}
            clickHandler={this.changeCitizenship}
            changeChosenQuarter={this.changeChosenQuarter}
            showQuarterList={this.state.showQuarterList}
          />
        </ContainerDimensions>

        {/*{this.state.readerMadeHisChoice &&*/}
          <Section1
            readerIsCityCitizen={this.state.readerIsCityCitizen}
            readerMadeHisChoice={this.state.readerMadeHisChoice}
            quarter={this.state.chosenQuarterName}
            circle={this.state.chosenCircleName}
          />
        {/*}*/}

        {/*{this.state.readerMadeHisChoice &&*/}
          <SVGQuarterMap
            dataSource={this.state.dataSource}
            mapId='zh-quarter-map'
            mapTitle='Sozialhilfequote nach Stadtquartieren'
            mapLead='Die verwendeten Daten beziehen sich auf das Jahr 2014.'
            height={640}
            width={640}
            mapSource={zhQuarterMap}
            mapData={zhQuarterMapData}
            mapDataYear={2014}
            readerIsCityCitizen={this.state.readerIsCityCitizen}
            readerMadeHisChoice={this.state.readerMadeHisChoice}
            sortProp='QuartSort'
          />
        {/*}*/}

        {/*<SVGCircleMap*/}
          {/*dataSource={this.state.dataSource}*/}
          {/*mapId='zh-circle-map'*/}
          {/*mapTitle='Karte der 12 Zürcher Kreise'*/}
          {/*mapLead='Lead zu der Karte wird in Main.js definiert. Gibt es zu den Kreisen keine Daten für 2015?'*/}
          {/*height={640}*/}
          {/*width={640}*/}
          {/*mapSource={zhCircleMap}*/}
          {/*mapData={zhCircleMapData}*/}
          {/*mapDataYear={2014}*/}
          {/*readerIsCityCitizen={this.state.readerIsCityCitizen}*/}
          {/*readerMadeHisChoice={this.state.readerMadeHisChoice}*/}
          {/*sortProp='KreisSort'*/}
        {/*/>*/}

        {/*{this.state.readerMadeHisChoice &&*/}
          <Section2
            readerIsCityCitizen={this.state.readerIsCityCitizen}
            readerMadeHisChoice={this.state.readerMadeHisChoice}
            quarter={this.state.chosenQuarterName}
            circle={this.state.chosenCircleName}
          />
        {/*}*/}

        {/*{this.state.readerMadeHisChoice &&*/}
          <div
            className={`ui  dimmable ${this.state.readerMadeHisChoice ? '' : 'dimmed'} segment  linechart`}
          >
            <div
              className='ui inverted simple dimmer'
              style={{
                display: this.state.readerMadeHisChoice ? 'none' : 'block'
              }}
            >
            </div>


            <ContainerDimensions>
              <MultipleLineChart
                readerIsCityCitizen={this.state.readerIsCityCitizen}
                readerMadeHisChoice={this.state.readerMadeHisChoice}
              />
            </ContainerDimensions>


            <Section3
              readerIsCityCitizen={this.state.readerIsCityCitizen}
              readerMadeHisChoice={this.state.readerMadeHisChoice}
            />

            {/* QUIZ */}
            <iframe
              src='http://interaktiv.tagesanzeiger.ch/guessgame/front/quiz/show-single/139/537'
              width='100%'
              height='250'
              scrolling='no'
              style={{border: '0px', marginTop: '15px', overflow: 'hidden', width: '100%', minHeight: '380px'}}
            >
            </iframe>

            <Section4
              readerIsCityCitizen={this.state.readerIsCityCitizen}
              readerMadeHisChoice={this.state.readerMadeHisChoice}
            />

            <ContainerDimensions>
              <Video />
            </ContainerDimensions>

            <Section5
              readerIsCityCitizen={this.state.readerIsCityCitizen}
              readerMadeHisChoice={this.state.readerMadeHisChoice}
              quarter={this.state.chosenQuarterName}
              circle={this.state.chosenCircleName}
            />

            <ContainerDimensions>
              <SmallMultiples
                readerIsCityCitizen={this.state.readerIsCityCitizen}
                readerMadeHisChoice={this.state.readerMadeHisChoice}
              />
            </ContainerDimensions>

            <Section6
              readerIsCityCitizen={this.state.readerIsCityCitizen}
              readerMadeHisChoice={this.state.readerMadeHisChoice}
            />

          </div>
        {/*}*/}


        <Footer
          handler={this.switchOverlay}
          shareUrl='http://interaktiv.tagesanzeiger.ch/2016/armut-in-zuerich/'
          twitterShareText='In Zürich leben Zehntausende Menschen in Armut. Oliver ist einer von ihnen. Eine Abstiegsgeschichte: https://goo.gl/dtIgjV @tagesanzeiger '
        />

          <Tracking
            articleId='19748408'
            projectId='armut-in-zuerich'
          />




      </div>

    );
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/main/Main.js